/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UpdateDeliveryDriverParcelsRequestDeliveryParcelsInner } from './UpdateDeliveryDriverParcelsRequestDeliveryParcelsInner';
import {
    UpdateDeliveryDriverParcelsRequestDeliveryParcelsInnerFromJSON,
    UpdateDeliveryDriverParcelsRequestDeliveryParcelsInnerFromJSONTyped,
    UpdateDeliveryDriverParcelsRequestDeliveryParcelsInnerToJSON,
} from './UpdateDeliveryDriverParcelsRequestDeliveryParcelsInner';

/**
 * 
 * @export
 * @interface UpdateDeliveryDriverParcelsRequest
 */
export interface UpdateDeliveryDriverParcelsRequest {
    /**
     * 
     * @type {Array<UpdateDeliveryDriverParcelsRequestDeliveryParcelsInner>}
     * @memberof UpdateDeliveryDriverParcelsRequest
     */
    deliveryParcels: Array<UpdateDeliveryDriverParcelsRequestDeliveryParcelsInner>;
}

/**
 * Check if a given object implements the UpdateDeliveryDriverParcelsRequest interface.
 */
export function instanceOfUpdateDeliveryDriverParcelsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "deliveryParcels" in value;

    return isInstance;
}

export function UpdateDeliveryDriverParcelsRequestFromJSON(json: any): UpdateDeliveryDriverParcelsRequest {
    return UpdateDeliveryDriverParcelsRequestFromJSONTyped(json, false);
}

export function UpdateDeliveryDriverParcelsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDeliveryDriverParcelsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'deliveryParcels': ((json['delivery_parcels'] as Array<any>).map(UpdateDeliveryDriverParcelsRequestDeliveryParcelsInnerFromJSON)),
    };
}

export function UpdateDeliveryDriverParcelsRequestToJSON(value?: UpdateDeliveryDriverParcelsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'delivery_parcels': ((value.deliveryParcels as Array<any>).map(UpdateDeliveryDriverParcelsRequestDeliveryParcelsInnerToJSON)),
    };
}

